import React, { createRef, useEffect } from 'react';
import QuickSearchResult from './QuickSearchResult';
import QuickSearchCompletionContainer from "../Containers/QuickSearchCompletion.Container"
import { translate } from '../Services/translation';
import QuickSearchSuggestions from './QuickSearchSuggestions';
import { AlgoliaQuickSearchBox } from './Algolia/Algolia';

const QuickSearch = props => {
    const searchInput = createRef();
    const { loading, query, products, result, showAll, noHit, active, onSearch, onKeyDown, toggleQuickSearchActive, selectedItem, searchUrl, blocks, settings, completionSuggestions, nameSuggestions, algoliaSettings } = props;
    const { isSearchPage } = settings;
    useEffect(() => {
        if (searchInput && searchInput.current)
            searchInput.current.focus();
    }, [searchInput]);

    useEffect(() => {
        if (algoliaSettings.isActive && isSearchPage && !active) {
            toggleQuickSearchActive();
        }
    }, []);

    const onCrossClick = () => {
        toggleQuickSearchActive()
        onSearch("")
    };

    const handleKeyPress = (e) => {
        if (e.key == "Enter") {
            window.location.href = searchUrl;
        }
        else if (e.key == "Escape") {
            onCrossClick();
        }
    }

    const onSuggestionClick = (text) => {
        console.log(searchInput.current);
        searchInput.current.value = text;
        onSearch(encodeURIComponent(searchInput.current.value));
    }

    return (
        <div className="quick-search" role="search">
            {window.__litium.algoliaSettings.isActive ? (
                <>
                    {active ? (
                        <>
                            <div className={`quick-search__form quick-search__form--algolia ${active ? 'quick-search__form--force-show' : ''}`} role="search">
                                <AlgoliaQuickSearchBox />
                            </div>
                            <a className="header__link-block" onClick={() => window.history.back()}>
                                <i className="ph-x"></i>
                            </a>
                        </>
                    ) : (
                        <a className="header__link-block" href={window.__litium.quickSearchUrl}>
                            <i className="icon-search"></i>
                        </a>
                    )}
                </>
            ) : (
                <>
                    <a className="header__link-block" onClick={e => toggleQuickSearchActive()}>
                        <i className="icon-search"></i>
                    </a>
                    <div className={`quick-search__form ${active ? 'quick-search__form--force-show' : ''}`} role="search">
                        <i className="icon-search" onClick={e => toggleQuickSearchActive()}></i>
                        <input id="quickSearchInput" className="quick-search__input" type="text" placeholder={translate('general.search')}
                            autoComplete="off" value={decodeURIComponent(query)} onChange={event => onSearch(encodeURIComponent(event.target.value))}
                            onKeyDown={event => onKeyDown(event, { searchUrl })} ref={searchInput}
                            onKeyUp={handleKeyPress} />
                        <div className="quick-search__icon-wrapper">
                            {!loading && <i onClick={onCrossClick} className="ph-x"></i>}
                            {loading && <i className="ph-arrow-clockwise spin"></i>}
                            <i className="icon-search"></i>
                        </div>
                        {active && <QuickSearchResult result={result} products={products} blocks={blocks} settings={settings} showAll={showAll} noHit={noHit} selectedItem={selectedItem} searchUrl={searchUrl} completionSuggestions={completionSuggestions} query={query} nameSuggestions={nameSuggestions} />}
                    </div>
                </>
            )}
        </div>
    );
}

export default QuickSearch;